import { render, staticRenderFns } from "./DailySalesReportMargin.vue?vue&type=template&id=49ee5638&"
import script from "./DailySalesReportMargin.vue?vue&type=script&lang=js&"
export * from "./DailySalesReportMargin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports